export const CREATE_ADMIN_FORM_DEFAULT_VALUES = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
};

export const CREATE_FIRM_FORM_DEFAULT_VALUES = {
  id: '',
  name: '',
  tin: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  trustAccountNumber: '',
  trustAccountRoutingNumber: '',
  brandColor: '',
  zendeskBrandName: '',
  docusignAccountId: '',
  sendAppInviteTrigger: '',
  createWalletTrigger: '',
  issueVirtualCardTrigger: '',
  issuePhysicalCardTrigger: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  isClientTriggerActive: false,
  docusignIntegrationKey: '',
  docusignUserId: '',
  docusignPublicKey: '',
};

export const MANAGE_ACCOUNT_FORM_DEFAULT_VALUES = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
  isPinSet: false,
};

export const CREATE_USER_FORM_DEFAULT_VALUES = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
  roleId: '',
  firmId: '',
  status:'',
};

export const DEFENDANT_FORM_DEFAULT_VALUES = {
  id: '',
  firmId: '',
  name: '',
  referenceId: '',
};

export const CLIENT_CREATE_FORM_DEFAULT_VALUES = {
  autoGenerateClientEmail: true,
  autoGenerateClientAddress: true,
  firstName: '',
  middleName: '',
  lastName: '',
  referenceId: '',
  userId: '',
  email: '',
  phone: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  birthdate: null,
  ssn: '',
  onboardingOption: 'emailLinkOnly',
  onboardingConfiguration: null,
  onboardingLinkDeliveryChannel: null,
  onboardingOtpChannel: null,
};

export const CLIENT_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  firstName: '',
  middleName: '',
  lastName: '',
  referenceId: '',
  userId: '',
  email: '',
  phone: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  onboardingOption: 'emailLinkOnly',
  onboardingConfiguration: null,
  onboardingLinkDeliveryChannel: null,
  onboardingOtpChannel: null,
};

export const CASES_FORM_DEFAULT_VALUES = {
  id: '',
  referenceId: '',
  caseTypeCategory: '',
  type: { id: '', label: '' },
  trustAccount: { id: '', label: '' },
  firmId: '',
  filedAt: '',
  sol: '',
  clientId: { id: '', label: '' },
  defendant: [
    {
      defendantId: { id: '', label: '' },
      gross: '',
    },
  ],
  secondaryFirms: [],
};

export const FIRM_CODES_FORM_DEFAULT_VALUES = {
  code: '',
  name: '',
  dataFormat: '',
  category: '',
  prompt: '',
};

export const CASES_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  name: '',
  referenceId: '',
  caseTypeCategory: '',
  type: { id: '', label: '' },
  trustAccount: { id: '', label: '' },
  feePercentage: '',
  filedAt: '',
  sol: '',
  liens: '',
  advances: '',
  clientId: { id: '', label: '' },
  defendant: [
    {
      defendantId: { id: '', label: '' },
      gross: '',
    },
  ],
  secondaryFirms: [],
  paymentStarted: false,
};

export const DEDUCTIONS_CREATE_FORM_DEFAULT_VALUES = {
  id: '',
  isAssigned: false,
  defendant: { id: '', label: '' },
  type: '',
  amount: '',
  remittanceLines: [],
  vendorAccount: null,
  description: '',
  memo: '',
  uploadInvoice: '',
  disposition: 'Pay',
  paymentMethod: '',
  paymentAccount: null,
  remittanceContext: null,
  externalPaymentReference: '',
  // externalPaymentMemo: '',
  externalPaymentDate: null,
};

export const SETTLEMENTS_CREATE_FORM_DEFAULT_VALUES = {
  id: '',
  settlementType: 'standard',
  defendant: { id: '', label: '' },
  amount: 0,
  pipAmount: 0,
  lienReimbursementAmount: 0,
  autoFillMemo: false,
  uploadedMemo: null,
};

export const DEDUCTIONS_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  referenceId: '',
  caseReferenceId: '',
  caseSystemName: '',
  firm: '',
  isAssigned: false,
  defendant: { id: '', label: '' },
  amount: '',
  remittanceLines: [],
  type: '',
  description: '',
  memo: '',
  uploadInvoice: '',
  disposition: '',
  vendorAccount: null,
  // docFileName: '',
  paymentMethod: '',
  paymentAccount: null,
  remittanceContext: null,
  preSettlementAmount: '',
  settlementAmount: undefined,
  entryDate: undefined,
  externalPaymentReference: '',
  // externalPaymentMemo: '',
  externalPaymentDate: null,
};

export const NET_SETTLEMENT_EDIT_FORM_DEFAULT_VALUES = {
  paymentIntention: '',
  externalPaymentMethod: '',
  externalPaymentReference: '',
  externalPaymentMemo: '',
  externalPaymentDate: null,
};

export const ATTORNEY_FEE_EDIT_POPUP_FORM_DEFAULT_VALUES = {
  disposition: '',
  paymentMethod: '',
  externalPaymentReference: '',
  externalPaymentMemo: '',
  externalPaymentDate: null,
};

export const ATTORNEY_FEE_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  name: '',
  fee: 0,
  role: '',
  disposition: '',
  paymentMethod: '',
};

export const DEDUCTION_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  type: '',
  amount: 0,
  vendorParticipationId: null,
  vendorName: { id: '', label: '', defaultPaymentMethod: '' },
  description: '',
  paymentMethod: '',
  paymentAccount: null,
  matchingMode: '',
  // memo: '',
  originalText: '',
  // disposition: '',
};

export const SETTLEMENTS_EDIT_FORM_DEFAULT_VALUES = {
  id: 0,
  caseReferenceId: '',
  caseSystemName: '',
  firm: '',
  defendant: { id: 0, label: '' },
  plaintiff: {
    id: 0,
    fullName: '',
  },
  deduction: [],
  expenses: [],
  attorneysFees: [],
  netSettlement: [],
  amount: 0,
};

export const DOCUMENTS_CREATE_FORM_DEFAULT_VALUES = {
  name: '',
};

export const DOCUMENTS_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  status: '',
  updatedAt: '',
  case: { id: '', name: '', referenceId: '' },
  completedAt: '',
  createdAt: '',
  fileId: '',
  firm: { id: '', name: '' },
  name: '',
  plaintiffFullName: '',
  documentUrl: '',
  plaintiffId: '',
};

export const SIGNATURES_CREATE_FORM_DEFAULT_VALUES = {
  caseId: { id: '', label: '' },
  name: '',
  documentId: '',
};

export const SIGNATURES_EDIT_FORM_DEFAULT_VALUES = {
  id: '',
  status: '',
  updatedAt: '',
  case: { id: '', name: '', referenceId: '' },
  completedAt: '',
  createdAt: '',
  firm: { id: '', name: '' },
  name: '',
  documentId: '',
  plaintiff: { id: '', firstName: '', middleName: '', lastName: '' },
  plaintiffFullName: '',
  documentUrl: '',
  fileId: '',
};

export const DATA_CREATE_FORM_DEFAULT_VALUES = {
  caseId: 0,
  name: '',
  notes: '',
  message: '',
};

export const DATA_EDIT_FORM_DEFAULT_VALUES = {
  form: null,
  answers: [],
  status: '',
  id: 0,
  name: '',
  case: {
    id: 0,
    name: '',
    referenceId: '',
    type: {
      id: 0,
      name: '',
    },
  },
  firm: {
    id: 0,
    name: '',
  },
  plaintiff: {
    id: 0,
    firstName: '',
    middleName: '',
    lastName: '',
  },
  plaintiffFullName: '',
  notes: '',
  message: '',
  formItemsCount: 0,
  formItemAnswersCount: 0,
};

export const SIGN_IN_FORM_DEFAULT_VALUES = {
  email: '',
  password: '',
};

export const CHANGE_PASSWORD_FORM_DEFAULT_VALUES = {
  newPassword: '',
  repeatNewPassword: '',
};

export const FORGOT_PASSWORD_FORM_DEFAULT_VALUES = {
  email: '',
};

export const RESET_PASSWORD_FORM_DEFAULT_VALUES = {
  code: '',
  newPassword: '',
  repeatNewPassword: '',
};

// React Hook Form values
export interface CaseAttorneyFeesFormValues {
  caseFeesConfig: {
    variableFeePercent?: string;
    maximumAmount?: string;
    variableFeeBasis: string;
  };
  secondaryFirms: Array<{
    id: number;
    name: string;
    role: 'CoCounsel' | 'ReferringCounsel';
    config: {
      fixedFeeAmount?: string;
      variableFeePercent?: string;
      variableFeeMaximumAmount?: string;
      variableFeeBasis: string;
    };
  }>;
  newFirm: {
    isAddingFirm?: boolean;
    lawFirm: {
      id?: string | null;
      label?: string | null;
    } | null;
    role?: string | null;
    fixedFeeAmount?: string | null;
    variableFeePercent?: string | null;
    variableFeeMaximumAmount?: string | null;
    variableFeeBasis?: string | null;
  };
}

export const CASE_ATTORNEYS_FEES_FORM_DEFAULT_VALUES: CaseAttorneyFeesFormValues = {
  caseFeesConfig: {
    variableFeePercent: '',
    maximumAmount: '',
    variableFeeBasis: 'Gross Settlement',
  },
  secondaryFirms: [],
  newFirm: {
    isAddingFirm: false,
    lawFirm: {
      id: '',
      label: '',
    },
    role: null,
    fixedFeeAmount: '',
    variableFeePercent: '',
    variableFeeMaximumAmount: '',
    variableFeeBasis: 'Attorneys’ Fees',
  },
};

export const REQUEST_DEMO_FORM_DEFAULT_VALUES = {
  userName: '',
  email: '',
  message: '',
  isAgreed: false,
};

export const QUESTIONNAIRE_FORM_BUILDER_DEFAULT_VALUES = {
  name: '',
  form: {
    sections: [
      {
        title: '',
        items: [],
        immutable: false,
      },
    ],
  },
};

export const DATA_REQUEST_FORM_BUILDER_DEFAULT_VALUES = {
  form: {
    sections: [
      {
        title: '',
        items: [],
        immutable: false,
      },
    ],
  },
};

export const FORM_SNIPPET_BUILDER_DEFAULT_VALUES = {
  name: '',
  data: {
    items: [],
  },
};

export const ACCOUNT_DELETION_REQUEST_DEFAULT_VALUES = {
  email: '',
};

export const REQUEST_SUPPORT_FORM_DEFAULT_VALUES = {
  name: '',
  email: '',
  message: '',
};

export const EMAIL_CONFIRMATION_FORM_DEFAULT_VALUES = {
  ssn: '',
  birthdate: null,
};

export const EDIT_CLIENT_SSN_DOB_FORM_DEFAULT_VALUES = {
  ssn: '',
  birthdate: null,
};

export const CONFIRM_2FA_CODE_FORM_DEFAULT_VALUES = {
  verificationCode: '',
};

export const FIRM_BANKING_ACCOUNT_CREATE_DEFAULT_VALUES = {
  name: '',
  type: '',
  accountNumber: '',
  routingNumber: '',
};

export const VENDOR_ACCOUNT_CREATE_DEFAULT_VALUES = {
  name: '',
  tin: '',
  vendorType: '',
  mailingPhoneNumber: '',
  email: '',
  isVendorConfirmationRequired: false,
  achEnabled: true,
  checkMailingEnabled: false,
  defaultAchEnabled: true,
  defaultCheckMailingEnabled: false,
  sameAsVendorAddress: false,
  accountType: '',
  accountNumber: '',
  routingNumber: '',
  mailingAddress1: '',
  mailingAddress2: '',
  mailingCity: '',
  mailingState: '',
  mailingZip: '',
  participationAddress1: '',
  participationAddress2: '',
  participationCity: '',
  participationState: '',
  participationZip: '',
  defaultPaymentMethod: '',
  isAddressVerified: false,
  isMailingAddressVerified: false,
  contactName: '',
  notes: '',
  externalVendorId: null,
  achAccounts: [],
  checkAccounts: [],
  files: [],
};

export const QUICKBOOKS_VENDOR_DEFAULT_VALUES = {
  companyName: '',
  displayName: '',
  email: '',
  phoneNumber: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  isAddressVerified: false,
};

export const VENDOR_ACCOUNT_EDIT_DEFAULT_VALUES = {
  id: '',
  name: '',
  tin: '',
  vendorType: '',
  mailingPhoneNumber: '',
  email: '',
  isVendorConfirmationRequired: false,
  achEnabled: true,
  checkMailingEnabled: false,
  defaultAchEnabled: true,
  defaultCheckMailingEnabled: false,
  sameAsVendorAddress: false,
  accountType: '',
  accountNumber: '************',
  routingNumber: '',
  mailingAddress1: '',
  mailingAddress2: '',
  mailingCity: '',
  mailingState: '',
  mailingZip: '',
  participationAddress1: '',
  participationAddress2: '',
  participationCity: '',
  participationState: '',
  participationZip: '',
  defaultPaymentMethod: '',
  isAddressVerified: false,
  isMailingAddressVerified: false,
  contactName: '',
  notes: '',
  achAccounts: [],
  checkAccounts: [],
};

export const VENDOR_CONFIRMATION_FORM_DEFAULT_VALUES = {
  name: '',
  accountType: '',
  accountNumber: '',
  routingNumber: '',
  mailingAddress1: '',
  mailingAddress2: '',
  mailingCity: '',
  mailingState: '',
  mailingZipCode: '',
  isAddressVerified: false,
  isAccountDetailsActive: false,
  isAddressDetailsActive: false,
  phoneNumber: '',
  email: '',
  participationAddress1: '',
  participationAddress2: '',
  participationCity: '',
  participationState: '',
  participationZip: '',
  vendorType: '',
  defaultPaymentMethod: '',
  isparticipationAddressVerified: false,
  isParticipationAddressActive: false,
  contactName: '',
};

export const FIRM_TRUST_ACCOUNT_FORM_DEFAULT_VALUES = {
  name: '',
  type: '',
  accountNumber: '',
  routingNumber: '',
};

export const FIRM_WITHDRAW_FUNDS_FORM_DEFAULT_VALUES = {
  fromSystemAccountType: '',
  toUnrestrictedAccountId: '',
  amount: '',
};

export const DATA_FILE_DOWNLOAD_TEMPLATE_FORM_DEFAULT_VALUES = {
  fileType: '',
};

export const DATA_FILE_UPLOAD_FORM_DEFAULT_VALUES = {
  fileType: '',
  fileName: '',
  sendVia: 'SMS',
  access: 'appOnly',
  sendInvitationVia: false,
  fileData: '',
};

export const PAY_SETTLEMENT_FORM_DEFAULT_VALUES = {
  numbers: new Array(4).fill({ value: '' }),
};

export const LIEN_RECOVERY_FORM_DEFAULT_VALUES = {
  amount: '',
  dateReceived: null,
  reason: '',
  note: '',
  attachment: null,
};
